import React from "react";

const Connections = () => {
    return (
        <div id={"connections"}>

            <h3 id="connections">Connections</h3>

            <div>

                <div className="imageContainer">
                    <img src="/images/REST_block.png" alt="REST Block" />
                </div>

                <p>
                    The <strong>Connections</strong> toolbox category allows you to send RESTful requests to third-party APIs.
                    The REST block supports these HTTP methods:
                </p>

                <ul>
                    <li>
                        <strong>GET</strong> – Used to <em>fetch</em> data from a server.
                    </li>
                    <br />
                    <li>
                        <strong>POST</strong> – Used to <em>send</em> data to a server.
                    </li>
                    <br />
                    <li>
                        <strong>PUT</strong> – Used to <em>update</em> existing data on a server.
                    </li>
                    <br />
                    <li>
                        <strong>DELETE</strong> – Used to <em>remove</em> data from a server.
                    </li>
                </ul>

                <p>
                    You can specify the <strong>URL</strong> of the API you want to connect to directly in the block.
                    Additionally, you may enter the following (if required):
                </p>
                
                <ul>
                    <li>
                        <strong>Authentication</strong> – Enter a username and password in the <em>Authentication</em> tab for Basic Authentication.
                    </li>
                    <br />
                    <li>
                        <strong>Headers</strong> – Add custom headers as key-value pairs to include metadata like <code>Content-Type</code> or <code>Authorization</code>.
                    </li>
                    <br />
                    <li>
                        <strong>Query Strings</strong> – Append key-value pairs to the URL to filter or modify the request (e.g., enter "userId" as the key and "123" as the value to add the query string <code>?userId=123</code>).
                    </li>
                </ul>

                <p>
                    Use the <strong>Set Schema</strong> button to define the expected structure of the JSON response. This will allow you to access values within the JSON object using the Response Data block below.
                </p>

                <p>
                    In the Set Schema window, click <strong> Get Response from URL</strong> to test the connection to the API. If the API responds successfully, the response will be shown in the window.
                    Then, click <strong>Apply</strong> to set the structure of the Response Data block.
                </p>

                <p>
                    Afterwards, you can navigate through the JSON structure using the +/- buttons and dropdowns to access values within the JSON response.
                </p>

                <div className="imageContainer">
                    <img src="/images/rest-test.gif" alt="Rest Test" />
                </div>

                <p>
                    The block also includes hooks for handling outcomes:
                </p>

                <ul>
                    <li><strong>On Success</strong> – Trigger actions when the request completes successfully.</li>
                    <br />
                    <li><strong>On Failure</strong> – Trigger actions when the request fails, allowing you to show error messages or retry.</li>
                </ul>

                <p>
                    <strong>Proxy Toggle</strong> - At the bottom-right corner of the block, this toggle lets you enable or disable proxy usage. When enabled, requests are routed through a proxy server, which acts as a middle layer between your device and the internet.
                    Using a proxy can help improve security, protect your privacy by hiding your IP address, and assist with testing by simulating different network conditions.
                </p>

            </div>
        </div>

    );
};

export default Connections;
